var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32129 19.0001H6.73529L16.0493 9.68608L14.6353 8.27208L5.32129 17.5861V19.0001ZM21.3213 21.0001H3.32129V16.7571L16.7563 3.32208C16.9438 3.13461 17.1981 3.0293 17.4633 3.0293C17.7285 3.0293 17.9828 3.13461 18.1703 3.32208L20.9993 6.15108C21.1868 6.33861 21.2921 6.59292 21.2921 6.85808C21.2921 7.12325 21.1868 7.37756 20.9993 7.56508L9.56429 19.0001H21.3213V21.0001ZM16.0493 6.85808L17.4633 8.27208L18.8773 6.85808L17.4633 5.44408L16.0493 6.85808Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd9b0d33deca8f377ebf2a88e807fcf1.svg";
export { ForwardRef as ReactComponent };